<template>
    <div class="product-poster mt-3 mt-sm-0">
        <span class="product-poster__title fwb">{{ title || dictionary.todayAction }}</span>
        <slot name="product" v-bind="{ product }">
            <TheProduct
                :dictionary="dictionary"
                :row="true"
                :item="product"
                :is-pwa="isPwa"
                :basket-amount="basketAmount"
                @hideMenu="$emit('hideMenu')"
                @addProductToBasket="addProductToBasket"
                @redirectToUrl="redirectToUrl"
            />
        </slot>
    </div>
</template>

<script>
import TheProduct from './TheProduct.vue'

export default {
    components: {
        TheProduct,
    },
    props: {
        basketAmount: {
            type: Number,
            required: true,
        },
        isPwa: {
            type: Boolean,
            required: true,
        },
        product: {
            type: Object,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        dictionary: {
            type: Object,
            required: true,
        },
    },
    methods: {
        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },

        redirectToUrl(data) {
            this.$emit('redirectToUrl', data)
        },
    },
}
</script>

<style lang="scss">
.product-poster {
    display: grid;
    grid-gap: 5px;
    gap: 5px;

    @media (min-width: 480px) {
        padding: 20px;
    }

    @media (max-width: 980px) {
        position: relative;
        display: block;
        width: 100%;
        right: 0;
        top: 0;
        padding: 0 15px;
    }

    .product {
        padding: 1em;

        .product-badges,
        .addratings {
            display: none;
        }

        .discount {
            position: absolute;
            right: 0.5em;
            top: 0;
            color: #333;
        }

        .product__content {
            margin-top: 0;
        }

        @media (max-width: 780px) {
            padding-bottom: 50px;
        }
    }
    &__title {
        margin: 10px 0 0;
        display: block;
        font-size: 18px;
        color: #064740;
        font-weight: 700;
    }
}
.product-poster {
    .search__product__button {
        padding: 0;
    }
}

.mobile-product.product-poster {
    .product .product__content {
        margin-top: 20px;
    }
}
</style>
